import { render, staticRenderFns } from "./EmployeeDeleteCellRenderer.vue?vue&type=template&id=6ced5e1e&scoped=true&lang=pug&"
import script from "./EmployeeDeleteCellRenderer.vue?vue&type=script&lang=ts&"
export * from "./EmployeeDeleteCellRenderer.vue?vue&type=script&lang=ts&"
import style0 from "./EmployeeDeleteCellRenderer.vue?vue&type=style&index=0&id=6ced5e1e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ced5e1e",
  null
  
)

export default component.exports